export default "__VITE_ASSET__YJlPzdsy__"